import React from "react";
import PropTypes from "prop-types";
import { useGlobal } from "reactn";
import Select, { components } from "react-select";

export const Dropdown = ({ handleChange, categories, selectedCategory, placeHolderText }) => {
  const [theme] = useGlobal("theme");

  const customStyles = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      color: isSelected ? "white" : "black",
      fontFamily: theme.font,
      padding: 15,
      cursor: "pointer",
      background: isSelected ? theme.colors.gradient : "white",
      "&:hover": {
        background: isSelected ? theme.colors.primaryDark : "#f7f7f7",
      },
    }),
    control: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      // padding: 10,
      borderRadius: "50px",
      height: "40px",
      borderColor: theme.colors.primary,
      padding: "0 5px 0 7px",

      cursor: "pointer",
      boxShadow: "none",
      "&:hover": {
        borderColor: theme.colors.primary,
      },
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      padding: "",
    }),
    container: (provided) => ({
      ...provided,
      height: "40px",
      width: "250px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "black",
      padding: "0 8px",
      svg: {
        width: "30px",
        height: "30px",
      },
    }),
    indicatorContainer: (provided) => ({
      ...provided,
      padding: "10px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "10px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontFamily: theme.font,
      top: "45%",
      fontSize: "18px",
      "@media only screen and (max-width: 768px)": {
        ...provided["@media only screen and (max-width: 768px)"],
        fontSize: "16px",
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return {
        ...provided,
        opacity,
        fontFamily: theme.font,
        top: "45%",
        fontSize: "18px",
        transition,
      };
    },
  };
  return (
    <Select
      options={categories}
      value={selectedCategory}
      isClearable={true}
      placeholder={placeHolderText}
      styles={customStyles}
      onChange={handleChange}
    ></Select>
  );
};

Dropdown.propTypes = {};
